/**
 * ROTAS69 welcome popup.
 *
 * Вынесен из инлайна в snippets/r69-welcome-popup.liquid 30.08.2026. Причина — замер: Shopify
 * НЕ минифицирует инлайновый JS, но минифицирует assets/*.js на 54–62 % (проверено на трёх
 * файлах темы: utilities 32 887 → 13 685, theme-drawer 18 448 → 7 082, product-card 36 521 →
 * 16 828). Плюс инлайн не кэшируется между страницами и разбирается заново на каждой навигации,
 * а ассет с `?v=<хэш>` берётся из кэша.
 *
 * Переносить было безопасно, потому что блок оказался полностью статичным: ни одной
 * Liquid-подстановки внутри (проверено), весь конфиг приходит из data-атрибутов на #r69wp и из
 * fetch — то есть из РАЗМЕТКИ, которая осталась в сниппете. Зависимости от исполнения во время
 * парсинга нет: скрипт начинается с getElementById('r69wp') и выходит, если разметки нет, а
 * попап и так открывается по таймеру. `defer` этому не мешает.
 *
 * ЕСЛИ БУДЕШЬ ПРАВИТЬ: не вставляй сюда Liquid — файл статический. Всё, что зависит от настроек
 * или локали, передавай data-атрибутом на #r69wp, как сделано с market/locale/root.
 */
(function () {
  var root = document.getElementById('r69wp');
  if (!root) return;
  var teaser = document.getElementById('r69wp-teaser');
  var KEY = 'r69:wp';
  var CFG_KEY = 'r69:wpcfg3';
  // Почта подписавшегося — отдельным ключом, а не внутри r69:wp: r69:wp это состояние окна
  // (показан / закрыт / когда), а это персональные данные, которые читает аналитика. Имя в один
  // ряд с _r69_extid, который заводит переменная GTM «Meta - External ID».
  var EMAIL_KEY = '_r69_email';
  var PAGES_KEY = 'r69:wppages';
  // ?r69wp=preview — the admin's «Preview on the store»: the popup opens at once whatever its state and settings,
  // nothing is remembered and nothing goes to analytics.
  var injected = window.R69WP_CFG || null;
  var preview = !!injected;
  try { preview = preview || new URLSearchParams(location.search).get('r69wp') === 'preview'; } catch (e) { /* старый браузер */ }

  function state() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function save(patch) {
    if (preview) return;
    var s = state();
    for (var k in patch) s[k] = patch[k];
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) { /* private mode */ }
  }
  function dl(ev, extra) {
    if (preview) return;
    window.dataLayer = window.dataLayer || [];
    var payload = { event: ev };
    if (extra) for (var k in extra) payload[k] = extra[k];
    window.dataLayer.push(payload);
  }

  var st = state();
  if (st.s && !preview) return; // subscribed — never show the popup or the teaser again

  // Пришёл по ссылке из нашего письма: письма Shopify Email получают только подписанные, и
  // ссылки в них помечены utm_source=shopify_email. Запоминаем как подписанного — попап
  // этому браузеру больше не нужен (владелец 13.09.2026).
  try {
    if (!preview && new URLSearchParams(location.search).get('utm_source') === 'shopify_email') {
      save({ s: 1 });
      return;
    }
  } catch (e) { /* старый браузер без URLSearchParams — показываем как обычно */ }

  // Behaviour config comes from the wishlist app's "Popup" tab (worker KV) through the App
  // Proxy; cached in sessionStorage for 10 min so it costs one request per session.
  function getCfg() {
    if (injected) return Promise.resolve(injected);
    try {
      var c = JSON.parse(sessionStorage.getItem(CFG_KEY) || 'null');
      if (!preview && c && c.t && Date.now() - c.t < 600000 && c.cfg) return Promise.resolve(c.cfg);
    } catch (e) { /* fall through to fetch */ }
    return fetch('/apps/r69/popup-config')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var cfg = j && j.config;
        if (cfg) {
          try { sessionStorage.setItem(CFG_KEY, JSON.stringify({ t: Date.now(), cfg: cfg })); } catch (e) { /* private mode */ }
        }
        return cfg;
      });
  }

  // Pages seen in this visit (sessionStorage: a new visit starts again) — the «from page N» setting.
  var pages = 1;
  try {
    pages = (parseInt(sessionStorage.getItem(PAGES_KEY) || '0', 10) || 0) + 1;
    sessionStorage.setItem(PAGES_KEY, String(pages));
  } catch (e) { /* private mode — counts as the first page */ }

  getCfg()
    .then(function (cfg) {
      cfg = cfg && pick(cfg);
      if (cfg && (cfg.enabled || preview)) init(cfg);
    })
    .catch(function () { /* config unavailable — popup stays off */ });

  // the page type of a template, as the app's «Where» setting names them
  function pageType(t) {
    t = String(t || '');
    if (t === 'index') return 'home';
    if (t === 'collection' || t === 'list-collections') return 'collection';
    if (t === 'product' || t === 'cart' || t === 'search') return t;
    if (t === 'page' || t === 'blog' || t === 'article') return 'content';
    if (t.indexOf('customers/') === 0) return 'account';
    return 'other';
  }

  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  function storeOf() {
    var tld = String(root.dataset.host || location.hostname).split('.').pop();
    return tld === 'lt' || tld === 'ee' || tld === 'com' ? tld : 'lv';
  }
  function storeKey() {
    return storeOf() + (root.dataset.locale === 'ru' ? '-ru' : '');
  }
  function pick(c) {
    var own = c && c.by_store && c.by_store[storeKey()];
    return own ? Object.assign({}, c, own) : c;
  }
  function textsOf(cfg) {
    var loc = root.dataset.locale;
    if (loc === 'ru' && cfg.ru_split && cfg.texts_ru) return cfg.texts_ru[storeOf()];
    return cfg.texts && cfg.texts[loc];
  }

  function look(cfg) {
    var d = cfg.design;
    var css = {
      '--wp-radius': d.radius + 'px',
      '--wp-ctl-radius': d.ctl_radius + 'px',
      '--wp-width': d.width + 'px',
      '--wp-img-d': String(d.img_d_pct),
      '--wp-img-m': String(d.img_m_pct),
      '--wp-text-d': String(d.text_d / 100),
      '--wp-text-m': String(d.text_m / 100),
      '--wp-dim': String(d.dim / 100),
      '--wp-focus': d.focus,
    };
    for (var k in css) root.style.setProperty(k, css[k]);
    root.dataset.imgD = d.img_d;
    root.dataset.imgM = d.img_m;
    root.dataset.alignD = d.align_d;
    root.dataset.alignM = d.align_m;
    var img = root.querySelector('.r69wp__img');
    var m = cfg.image && /^https:\/\/cdn\.shopify\.com\/s\/files\/[\d/]+\/files\/([^?#]+)(?:\?v=(\d+))?/.exec(cfg.image.url);
    root.dataset.img = m ? '1' : '0';
    if (m && img) {
      var base = '/cdn/shop/files/' + m[1] + (m[2] ? '?v=' + m[2] + '&' : '?') + 'width=';
      var slot = d.img_d === 'top' ? d.width : Math.round((d.width * d.img_d_pct) / 100);
      img.sizes = '(min-width: 750px) ' + slot + 'px, 100vw';
      img.srcset = [450, 700, 900, 1200].map(function (w) { return base + w + ' ' + w + 'w'; }).join(', ');
      img.width = 900;
      img.height = Math.round((900 * cfg.image.h) / cfg.image.w);
      img.src = base + 900;
    }
    if (teaser) {
      teaser.style.setProperty('--wp-ctl-radius', d.ctl_radius + 'px');
      teaser.className = teaser.className.replace(/\s*r69wp-teaser--\S+/g, '');
      teaser.classList.add('r69wp-teaser--' + (isMobile ? cfg.teaser_pos_m : cfg.teaser_pos));
    }
    var t = textsOf(cfg);
    [root, teaser].forEach(function (box) {
      if (!box) return;
      box.querySelectorAll('[data-wp-t]').forEach(function (el) { el.textContent = t[el.dataset.wpT]; });
      box.querySelectorAll('[data-wp-t-label]').forEach(function (el) { el.setAttribute('aria-label', t[el.dataset.wpTLabel]); });
      box.querySelectorAll('[data-wp-t-ph]').forEach(function (el) {
        el.placeholder = t[el.dataset.wpTPh];
        el.setAttribute('aria-label', t[el.dataset.wpTPh]);
      });
    });
    var codeSpan = root.querySelector('[data-wp-code]');
    if (codeSpan) codeSpan.textContent = cfg.coupon;
    var use = root.querySelector('[data-wp-use]');
    if (use) use.href = root.dataset.root.replace(/\/$/, '') + '/discount/' + cfg.coupon;
  }

  function init(cfg) {
    // Where it opens: this store + language and this page type (a setting missing from an older config — everywhere).
    if (!preview) {
      var store = storeKey();
      if (cfg.where && cfg.where.indexOf(store) < 0) return;
      if (cfg.skip_pages && cfg.skip_pages.indexOf(pageType(root.dataset.template)) >= 0) return;
    }
    if (!textsOf(cfg)) return;
    var reshowMs = cfg.reshow_days * 86400000;
    // The teaser's own × hides the chip for the reshow window (localStorage `tc`), separate
    // from closing the popup itself.
    function teaserClosedRecently() {
      var s = state();
      return !!(s.tc && Date.now() - s.tc < reshowMs);
    }
    var teaserAllowed =
      !!teaser &&
      cfg.teaser &&
      (cfg.teaser_devices === 'both' || (cfg.teaser_devices === 'mobile') === isMobile);
    look(cfg);
    if (injected) window.R69WP_LOOK = function (c) { cfg = pick(c); look(cfg); };

    // The coupon is config-driven: inject the code + the locale-aware /discount/ URL.
    var use = root.querySelector('[data-wp-use]');
    if (use) use.addEventListener('click', function () { dl('r69_popup_discount_click'); });

    function openWP() {
      root.hidden = false;
      document.documentElement.classList.add('r69wp-open');
      if (teaser) teaser.hidden = true;
      dl('r69_popup_view');
      var inp = root.querySelector('.r69wp__input');
      if (inp && !inp.disabled && !injected) setTimeout(function () { inp.focus(); }, 80);
    }
    function closeWP() {
      root.hidden = true;
      document.documentElement.classList.remove('r69wp-open');
      // The teaser comes back a beat later, on purpose: showing it in the same frame as the close
      // cost 54 ms of forced style/layout on a Pixel-class phone at 4x CPU (collection page,
      // 06.09.2026 — the vertical chip lays out its rotated text), against 6 ms for hiding the
      // popup and 6 ms for the scroll unlock. That was most of the 192 ms the close tap measured
      // in INP; a 320 ms delay keeps it out of the interaction and nobody notices a chip
      // appearing a third of a second after the popup goes.
      save({ c: Date.now() });
      if (teaserAllowed && !state().s && !teaserClosedRecently()) setTimeout(function () { teaser.hidden = false; }, 320);
    }

    root.querySelectorAll('[data-wp-close]').forEach(function (el) {
      el.addEventListener('click', closeWP);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) closeWP();
    });
    if (teaser) {
      teaser.querySelector('[data-wp-teaser-open]').addEventListener('click', openWP);
      teaser.querySelector('[data-wp-teaser-close]').addEventListener('click', function (e) {
        e.stopPropagation();
        teaser.hidden = true;
        save({ tc: Date.now() });
      });
    }

    var form = root.querySelector('.r69wp__form');
    var err = root.querySelector('.r69wp__err');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      err.hidden = true;
      var email = form.email.value.trim();
      if (!email || email.indexOf('@') < 1) { err.hidden = false; return; }
      var btn = form.querySelector('.r69wp__btn');
      btn.disabled = true;
      fetch('/apps/r69/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, market: root.dataset.market, locale: root.dataset.locale }),
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) { return r.ok && j.ok ? j : null; });
        })
        .then(function (j) {
          // Воркер говорит, кто это (владелец 13.09.2026): code — код как раньше; known — уже был
          // подписан, заказов нет — «Ты уже с нами» и код; buyer — есть заказы, код ему не
          // сработает — только «подписан на новости». Незнакомый ответ — ошибка, а не код наугад.
          var status = j && j.status;
          if (status !== 'code' && status !== 'known' && status !== 'buyer') { err.hidden = false; return; }
          save({ s: 1 });
          root.querySelector('[data-wp-step="form"]').hidden = true;
          if (status === 'buyer') {
            root.querySelector('[data-wp-step="news"]').hidden = false;
          } else {
            if (status === 'known') {
              var done = root.querySelector('[data-wp-step="done"]');
              done.querySelector('[data-wp-t="success_title"]').textContent = textsOf(cfg).known_title;
              done.querySelector('[data-wp-t="success_sub"]').textContent = textsOf(cfg).known_sub;
            }
            root.querySelector('[data-wp-step="done"]').hidden = false;
          }
          // Почта уезжает в dataLayer вместе с событием подписки. Дальше её сама подхватывает
          // готовая цепочка GTM: DLV «user_data.email» -> переменная «U - Email» -> настройка
          // «GA4 - Event settings - User Data» -> поле user_data.email_address. Эта настройка
          // висит и на конфигурационном теге, и на всех событийных, поэтому почта попадёт во ВСЕ
          // последующие события ЭТОЙ страницы, оттуда на сервер, в Meta и в Enricher.
          //
          // Пуша мало: dataLayer живёт до первой же навигации, и на следующей странице почты уже
          // нет — проверено 09.09.2026, page_view после перехода уходил без user_data.email_address.
          // Поэтому адрес кладётся ещё и в localStorage: переменная «U - Email» читает этот ключ
          // сама, третьей веткой после dataLayer и customerShopStape, и почту получает уже
          // page_view следующей страницы — вот тогда человек и правда узнан в следующие визиты.
          //
          // Почему не кука: vsr.rotas69.lv лежит в зоне rotas69.lv, значит куку с domain=.rotas69.lv
          // браузер приложил бы КО ВСЕМ запросам витрины — адрес уезжал бы ещё и в Shopify, в
          // каждый запрос страницы и каждый /cdn. localStorage читает только наш тег, и адрес
          // уходит ровно туда, куда нужно, и ровно в аналитическом хите.
          //
          // Согласие: гейта тут нет и он не нужен. Человек сам ввёл адрес и нажал кнопку, а
          // распорядиться записанным может только тег GTM — а он без согласия не сработает.
          // (в предпросмотре из админки — не пишем: это проверка, а не посетитель)
          if (!preview) {
            try {
              localStorage.setItem(EMAIL_KEY, JSON.stringify({ e: email, t: Date.now() }));
            } catch (e) { /* private mode */ }
          }
          // Пушим ТОЛЬКО после успешной подписки: человек сам ввёл адрес и подтвердил согласие.
          dl('r69_popup_subscribe', { user_data: { email: email } });
        })
        .catch(function () { err.hidden = false; })
        .finally(function () { btn.disabled = false; });
    });

    var copyBtn = root.querySelector('[data-wp-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        if (!navigator.clipboard || !navigator.clipboard.writeText) return;
        navigator.clipboard.writeText(cfg.coupon).then(function () {
          var ok = root.querySelector('[data-wp-copied]');
          ok.hidden = false;
          setTimeout(function () { ok.hidden = true; }, 2000);
        });
      });
    }

    if (preview) { openWP(); return; }
    var closedRecently = st.c && Date.now() - st.c < reshowMs;
    if (closedRecently) {
      if (teaserAllowed && !teaserClosedRecently()) teaser.hidden = false;
    } else if (pages < (cfg.min_pages || 1)) {
      /* «From page N of a visit»: not yet — a later page of this visit opens it. */
    } else if (cfg.trigger === 'exit' && !isMobile && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      /* Leaving the page: the cursor goes out through the top edge of the window — towards the tabs, the address
         bar, the close button. Opens at once (a delay would miss the moment). Desktop only: a phone has no cursor,
         so there the first gesture below opens it. It follows a gesture by nature, so it can never be the LCP. */
      var onLeave = function (e) {
        if (e.relatedTarget || e.clientY > 0) return;
        document.removeEventListener('mouseout', onLeave);
        openWP();
      };
      document.addEventListener('mouseout', onLeave);
    } else if (cfg.trigger === 'load') {
      /* Owner chose the page-load trigger in the app: the delay counts from the LOAD event
         (not parse time), so even on a slow connection the popup lands AFTER first paint and
         can't become the LCP element. */
      var openAfterLoad = function () { setTimeout(openWP, cfg.delay * 1000); };
      if (document.readyState === 'complete') openAfterLoad();
      else window.addEventListener('load', openAfterLoad, { once: true });
    } else {
      /* Default trigger ('interaction'). A raw timer from page load put the popup's image on
         screen while the browser was still deciding the Largest Contentful Paint — it BECAME
         the LCP element (measured: hub 9.8s, PLP 16.8s in the throttled lab), and it also
         stacked on top of Shopify's consent dialog on a first visit.
         So the delay starts at the shopper's FIRST GESTURE (scroll / pointer / key / touch).
         That is better for both sides: LCP finalises on interaction anyway — after a gesture
         the popup can never be the LCP element — and a popup that arrives once someone is
         actually engaged converts better than one thrown at a page they have not begun to read.
         Nobody is lost either: a visitor who never gestures still gets it on the fallback
         below, deliberately far outside the measurement window. */
      var opened = false;
      var openOnce = function () {
        if (opened) return;
        opened = true;
        for (var gi = 0; gi < GESTURES.length; gi++) {
          window.removeEventListener(GESTURES[gi], onGesture, GESTURE_OPTS);
        }
        setTimeout(openWP, cfg.delay * 1000);
      };
      var GESTURES = ['pointerdown', 'touchstart', 'keydown', 'scroll', 'wheel', 'pointermove'];
      var GESTURE_OPTS = { passive: true };
      var onGesture = function () { openOnce(); };
      for (var g = 0; g < GESTURES.length; g++) {
        window.addEventListener(GESTURES[g], onGesture, GESTURE_OPTS);
      }
      /* NO timer fallback. The old "reader who never scrolls" net (15s after load) was the
         one opener a measurement run still hits: with zero input the browser never finalises
         LCP, so the popup image at load+15s BECAME the page's LCP and torched Speed Index on
         every page type (PSI 29.08: PLP 15.2s, policy 16.7s, refund SI 39s — all load+15s).
         A visitor who produces no gesture at all is a bot or a lab; pointermove is in the
         gesture list, so merely moving the mouse counts. Non-gesturing visitors simply keep
         the page; the teaser/reshow logic still covers later visits. */
    }
  }
})();
